export const environment = {
  production: true,
  sentryName: 'production',
  sentryReplaysRate: 0.1,
  apiDomain: 'https://api.pastime.com',
  domain: 'financerazor.com'
};